<div class="container-fluid container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="row g-0 align-items-stretch">
        <div class="col-lg-6 pe-md-12">
            <app-contact-form></app-contact-form>
        </div>
        <div class="col-lg-6">
            <div class="h-100 overflow-hidden">
                <img class="min-w-100 img-fluid item-md-center" src="assets/images/our_showroom_meet.jpg" alt="" />
            </div>
        </div>
    </div>
</div>
